import styled from "styled-components";

export const StyledContainer = styled.div`
  position: absolute;
  width: 100vw;
  padding: 0 1rem 0 1rem;
  border-bottom: 0.647405px solid rgba(255, 255, 255, 0.15);
`;

